import AscTextInput, { AscTextInputProps } from "../AscTextInput/AscTextInput";
import styles from "./AscSearchInput.module.scss";
import { SearchIcon } from "../../AscIcons";
import { useRef, useState } from "react";
import classNames from "classnames";

export interface AscSearchInputProps extends Omit<AscTextInputProps, "ref"> {
  ref?: React.Ref<HTMLInputElement>;
  variant?: "primary" | "secondary";
  className?: string;
}

export default function AscSearchInput({
  variant = "primary",
  className,
  ...props
}: AscSearchInputProps) {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  function handleOnBlur(e: React.FocusEvent<HTMLInputElement, Element>) {
    props?.onBlur?.(e);
    setFocused(false);
  }
  function handleOnFocus(e: React.FocusEvent<HTMLInputElement, Element>) {
    props?.onFocus?.(e);
    setFocused(true);
  }
  function handleOnParentDivClick() {
    inputRef.current?.focus();
    setFocused(true);
  }

  return (
    <AscTextInput
      className={classNames(styles.ground, className, {
        [styles.primary]: variant === "primary",
        [styles.secondary]: variant === "secondary",
        [styles.focused]: focused,
      })}
      innerInputClassName={styles.innerInputClassName}
      prefixIcon={<SearchIcon className={styles.searchIcon} />}
      placeholder="Search"
      ref={inputRef}
      {...props}
      onBlur={handleOnBlur}
      onFocus={handleOnFocus}
      onParentDivClick={handleOnParentDivClick}
    />
  );
}
